// src/components/LatestAddition.js
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import styled from 'styled-components';
import { NavLink } from "react-router-dom";

const Latestadditions = styled.div`
  text-align: start;
  background-color: ${window.ENV.GENERAL.BACKGROUND_COLOR};
`;

const Head = styled.h1`
  margin-left: 10px;
  margin-top: 20px;
  padding-top: 20px;
  font-family: ${window.ENV.FONT_FAMILY};

  @media (max-width: 768px) {
    margin-left: 50px;
    font-size: 1.5rem;
    padding-top: 15px;
  }

  @media (max-width: 480px) {
    margin-left: 20px;
    font-size: 1.2rem;
    padding-top: 10px;
    text-align: left;
    margin-bottom: 10px;
  }
`;

const Latestcarousel = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%;
  height: 350px;
  //overflow: hidden;

  @media (max-width: 768px) {
    height: 300px;
  }

  @media (max-width: 480px) {
    height: 270px;
  }
`;

const Prevsbutton = styled.button`
  position: static;
  margin-right: 8px;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 20px;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  background: transparent;

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 10px;
    margin-right: 4px;
  }

  @media (max-width: 480px) {
    padding: 6px;
    font-size: 10px;
    margin-right: 2px;
  }

  @media (max-width: 425px) {
    padding: 0px;
    font-size: 5px;
    margin-right: 1px;
  }

  @media (max-width: 1024px) and (min-width: 512px) {
    padding: 9px;
    font-size: 20px;
    margin-right: 1px;
  }
`;

const Nextsbutton = styled.button`
  position: static;
  margin-left: 8px;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 20px;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  background: transparent;

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 16px;
    margin-left: 4px;
  }

  @media (max-width: 425px) {
    padding: 0px;
    font-size: 2px;
    margin-left: 1px;
  }

  @media (max-width: 480px) {
    padding: 0px;
    font-size: 14px;
    margin-left: 2px;
  }
`;

const Latestgrid = styled.div`
  display: flex;
  gap: 20px;
  padding: 0;
  justify-content: flex-start;
  transition: transform 0.5s ease;
  will-change: transform;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: hidden;
    width: 100%;
    justify-content: center;
  }
`;

const Latestitem = styled.div`
  width: 250px;
  height: auto;
  border: 1px solid #ddd;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: ${window.ENV.GENERAL.PRODUCT_GRID_BOARDER_COLOR};
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.5s ease, box-shadow 0.5s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    width: 90vw;
    max-width: 300px;
    padding: 12px;
    margin: 0 0 0 0;
    border-radius: 10px;
  }
`;

const TextContainer = styled.div`
  margin-bottom: 10px;
  text-align: center;
`;

const LatesttName = styled.h4`
  font-size: 1rem;
  color: #003063;
  margin: 0;
  font-weight: 500;
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
  
  
`;

const LatestImage = styled.img`
  width: 80%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
`;

const LatestAddition = ({ visibleItems, nextSlide, prevSlide, transformValue }) => {
  return (
    <Latestadditions>
      <Head>Latest Addition</Head>
      <Latestcarousel>
        <Prevsbutton onClick={prevSlide}>
          <FaChevronLeft size={30} />
        </Prevsbutton>
        <Latestgrid style={{ transform: transformValue }}>
          {visibleItems.map((product, index) => (
            console.log("product in latest addition", product),
            <NavLink
              key={index}
              to={`/category/${product.categoryName}/productdetails/${product.productId}`}
              style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? window.ENV.GENERAL.BACKGROUND_COLOR : "inherit",
              })}
            >
              <Latestitem className="latest-item">
                <ImageContainer>
                  <LatestImage src={`${window.ENV.SERVER_URL}${product.isometric_view}`} alt={product.name} />
                </ImageContainer>
                <TextContainer>
                  <LatesttName>{product.productId
                  }</LatesttName>
                </TextContainer>
              </Latestitem>
            </NavLink>
          ))}
        </Latestgrid>
        <Nextsbutton onClick={nextSlide}>
          <FaChevronRight size={30} />
        </Nextsbutton>
      </Latestcarousel>
    </Latestadditions>
  );
};

export default LatestAddition;
